import joshPic from "@/public/images/artists/josh.png";
import { Artist } from "@/types/types";

export const josh = {
  id: "198",
  name: "Josh",
  image: joshPic,
  description: `Josh's delivery is assured and unforced, marked by a rough-hewn timbre and a pronounced rasp—ideal for injecting energy and character into any country track.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjosh-preview.mp3",
  meta: {
    // Must be free since artist is used in the tutorial
    free: true,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Country", "Rock", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 68,
      },
      sweetSpot: 55,
    },
  },
} as const satisfies Artist;
